/**
 * Route Constants
 * Centralized route definitions for the application
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  
  // Dashboard routes (will be nested)
  DASHBOARD: '/dashboard',
  DASHBOARD_HOME: '/dashboard',
  DASHBOARD_SEARCH: '/dashboard/search',
  DASHBOARD_SEARCH_ADVANCED: '/dashboard/search/advanced',
  DASHBOARD_SEARCH_ANALYTICS: '/dashboard/search/analytics',
  DASHBOARD_FAVORITES: '/dashboard/favorites',
  DASHBOARD_INSIGHTS: '/dashboard/insights',
  DASHBOARD_PROFILE: '/dashboard/profile',
  DASHBOARD_PROFILE_COMPANY: '/dashboard/profile/company',
  DASHBOARD_PROFILE_SUBSCRIPTIONS: '/dashboard/profile/subscriptions',
  DASHBOARD_PROFILE_TICKERS: '/dashboard/profile/tickers',
  DASHBOARD_ADMIN: '/dashboard/admin',
  DASHBOARD_RFQ: '/dashboard/rfq',
  DASHBOARD_MILEMAKER: '/dashboard/milemaker',
  DASHBOARD_NEWS: '/dashboard/news',
  DASHBOARD_TOP_RATES: '/dashboard/top-rates',
  
  // Subscription routes
  SUBSCRIPTION_SUCCESS: '/subscription-success',
  SUBSCRIPTION_CANCEL: '/subscription-cancel',
  
  // Pricing
  PRICING: '/pricing',
  
  // Auth routes
  CALLBACK: '/callback',
  
  // Fallback
  NOT_FOUND: '*'
};

/**
 * List of routes that require authentication
 */
export const PROTECTED_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.DASHBOARD_SEARCH,
  ROUTES.DASHBOARD_SEARCH_ADVANCED,
  ROUTES.DASHBOARD_SEARCH_ANALYTICS,
  ROUTES.DASHBOARD_FAVORITES,
  ROUTES.DASHBOARD_INSIGHTS,
  ROUTES.DASHBOARD_PROFILE,
  ROUTES.DASHBOARD_PROFILE_COMPANY,
  ROUTES.DASHBOARD_PROFILE_SUBSCRIPTIONS,
  ROUTES.DASHBOARD_PROFILE_TICKERS,
  ROUTES.DASHBOARD_ADMIN,
  ROUTES.DASHBOARD_RFQ,
  ROUTES.DASHBOARD_MILEMAKER,
  ROUTES.DASHBOARD_NEWS,
  ROUTES.DASHBOARD_TOP_RATES,
  ROUTES.PRICING,
  ROUTES.SUBSCRIPTION_CANCEL,
];

/**
 * Helper to check if a route is protected
 */
export const isProtectedRoute = (path) => {
  return PROTECTED_ROUTES.some(route => path.startsWith(route));
};

/**
 * Legacy URL query param mappings (for backward compatibility during migration)
 * Maps old query params to new routes
 */
export const LEGACY_TAB_MAPPINGS = {
  'tab=setup&subtab=profile': ROUTES.DASHBOARD_PROFILE,
  'tab=setup&subtab=company': ROUTES.DASHBOARD_PROFILE_COMPANY,
  'tab=setup&subtab=subscriptions': ROUTES.DASHBOARD_PROFILE_SUBSCRIPTIONS,
  'tab=setup&subtab=tickers': ROUTES.DASHBOARD_PROFILE_TICKERS,
};
